"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomeModificationRequest = void 0;
// FIXME: fromJSON版があるので削除できる
const immutable_1 = require("immutable");
const luxon_1 = require("luxon");
const ModificationRequest_1 = require("../entity/ModificationRequest");
const modificationRequestDeliverable_1 = require("./modificationRequestDeliverable");
const modificationRequestItem_1 = require("./modificationRequestItem");
const user_1 = require("./user");
const createSomeModificationRequest = ({ id = '123', bucketId = '123456', targetDeliverableId = '123', state = Object.keys(ModificationRequest_1.ModificationRequestState)[0], feedback = null, items = immutable_1.List(Object.keys(ModificationRequest_1.ModificationRequestItemType)).map((type) => modificationRequestItem_1.createSomeModificationRequestItem({ type })), sender = user_1.createSomeDirectorUser(), feeType = Object.keys(ModificationRequest_1.ModificationRequestFeeType)[1], deliverables = immutable_1.List([modificationRequestDeliverable_1.createSomeModificationRequestDeliverable()]), } = {}) => new ModificationRequest_1.default({
    id,
    bucketId,
    state,
    feedback,
    targetDeliverableId,
    items,
    sender,
    createdAt: luxon_1.DateTime.fromMillis(0, { zone: 'utc' }),
    submittedAt: luxon_1.DateTime.fromMillis(0, { zone: 'utc' }),
    deliveryDue: luxon_1.DateTime.fromMillis(10000, { zone: 'utc' }),
    feeType,
    deliverables,
});
exports.createSomeModificationRequest = createSomeModificationRequest;
